import React, { useEffect, useState } from "react";
import withdrawal from "../../assets/svg/withdrawalSvg.svg";
import svg46 from "../../assets/svg/svg46.svg";
import { Link, useActionData, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import svg56 from "../../assets/svg/svg56.svg";
import { Dropdown } from "antd";
import WalletUserModal from "./wallet-user/modal/WalletUserModal"; 

function PaymentHeader({ collectionWallet }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openUser, setopenUser] = useState(false);

  

  function handleCancelUser() {
    setopenUser(false);
  }

  const handleWithdraw = () => {
    navigate("/payment-page");
  };
  const handleWalletUser = async() => {
    await navigate('/wallet-users')
    // setopenUser(true);
  };
  const settingItemsQuickActions = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleWithdraw}
          className="flex  text-[16px] font-sans  !text-lightBlack py-1"
        >
          Top up Payment
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleWalletUser}
          className="flex  text-[16px] font-sans  !text-lightBlack py-1"
        >
          Add Wallet User
        </Link>
      ),
    },
  ];

 

  return (
    <div className="report-card  h-auto w-full p-3 mt-3">
      <div className="product_sub !text-[18px]">
        Collection Available Amount
      </div>
      <div className="flex items-center justify-between mt-2">
        <div className="text-[#222222] font-[600] text-[25px]">
          {collectionWallet?.walCurrency} {collectionWallet?.walAmount}
        </div>

        <div className="w-[230px]">
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItemsQuickActions }}
            placement="bottom"
          >
            <div className="w-[200px]">
              <button className="cstm-btn flex gap-x-2" type="submit">
                <img src={svg56} alt={svg56} /> Quick actions
              </button>
            </div>
          </Dropdown>

          {/* <button
            key="submit"
            type="submit"
            className="cstm-btn flex items-center gap-x-2 !rounded-[10px]"
            style={{ boxShadow: "0 4px 0 0 #2A662C" }}
            onClick={handleWithdraw}
          >
            <img src={withdrawal} alt="withdrawal" /> Top up Payment
          </button> */}
        </div>
      </div>
      <div className="mt-5 bg-[#F5F5F5] p-2 rounded-[8px] flex items-center gap-x-2">
        <img src={svg46} alt="svg46" />
        Earnings update is expected within 1 to 20 min following the users
        purchase of the product
      </div>

      <WalletUserModal open={openUser} handleCancel={handleCancelUser} collectionWallet={collectionWallet}/>
    </div>
  );
}

export default PaymentHeader;
